import React, {useEffect, useState} from "react";
import SvgIcon from "@mui/material/SvgIcon";
import "./RaikoTreeItem.scss"
import {css} from "@emotion/css";

export const RaikoTree = ({treeItems, handleItemClicked, selectedItemsId}) => {

    const [treeHeightContainer, setTreeHeightContainer] = useState(0);


    useEffect(() => {

        // callback function to call when event triggers
        const onPageLoad = () => {
            if (treeItems) {
                let height = document.getElementById('treeContainer').offsetHeight;
                setTreeHeightContainer(height)
            }
        };

        // Check if the page has already loaded
        if (document.readyState === 'complete') {
            onPageLoad();
        } else {
            window.addEventListener('load', onPageLoad, false);
            // Remove the event listener when component unmounts
            return () => window.removeEventListener('load', onPageLoad);
        }
    }, [treeItems])


    const [collapsedItems, setCollapsedItems] = useState([]);

    const isExist = (id) => {
        let state = false

        collapsedItems.map(item => {
            if (item === id) {
                state = true
            }
        })
        return state
    };

    function createTreeItem(treeItem, parentId) {
        if (treeItem.subCategory && treeItem.subCategory.length > 0) {
            return createParentTreeItem(treeItem, parentId)
        } else {
            return createFinalTreeItem(treeItem, parentId)
        }
    }

    function removeFromCollapsedItems(id) {
        const list = []
        collapsedItems.map(item => {
            if (item !== id)
                list.push(item)
        })

        setCollapsedItems(list)
    }


    function findIsSelected(id) {
        let state = false

        if (selectedItemsId && selectedItemsId.length > 0) {

            selectedItemsId.find(element => {
                if (element === id) {
                    state = true
                }
            })
        }
        return state
    }

    function createParentTreeItem(treeItem, parentId) {

        return <div
            className={`raikoTreeItemParentContainer`}
            onClick={(e) => {
                e.stopPropagation();
                handleItemClicked(treeItem.id, treeItem.name, parentId);
            }}
        >
            {
                <>
                    <div
                        className={`parentContainer ${findIsSelected(treeItem.id) ? `activeThreeItem` : ""}`}>

                        {isExist(treeItem.id) ?
                            <PlusSquare
                                onClick={e => {
                                    e.stopPropagation();
                                    removeFromCollapsedItems(treeItem.id)
                                }}
                            /> :
                            <MinusSquare
                                onClick={e => {
                                    e.stopPropagation();
                                    setCollapsedItems(prevState => [...prevState, treeItem.id])
                                }}/>
                        }
                        <span>{`${treeItem.name}`}</span>

                    </div>

                    {
                        <div
                            className={`childrenContainer 
                        ${!isExist(treeItem.id) ? "treeItemInAnimation" : "treeItemOutAnimation"} 
                       `}
                        >
                            {treeItem.subCategory.map((item) => {
                                return createTreeItem(item, treeItem.id)
                            })}
                        </div>
                    }

                </>
            }
        </div>
    }

    function createFinalTreeItem(treeItem, parentId) {
        return (
            <div
                className={`raikoTreeItemFinalChildContainer  ${findIsSelected(treeItem.id) ? `activeThreeItem` : ""}`}
                onClick={(e) => {
                    e.stopPropagation();
                    handleItemClicked(treeItem.id, treeItem.name, parentId);
                }}
            >
                <CloseSquare/>
                <span>{`${treeItem.name}`}</span>
            </div>
        );
    }

    return (
        <section
            id={'treeContainer'}
            className={css`width: 100%;
              min-height: ${treeHeightContainer}px !important;
              overflow: hidden;`}>
            {treeItems.map((treeItem, index) => {
                return createTreeItem(treeItem, -1)
            })}
        </section>
    )
}


function MinusSquare(props) {
    return (
        <SvgIcon fontSize="inherit" style={{width: 14, height: 14}} {...props}>
            {/* tslint:disable-next-line: max-line-length */}
            <path
                d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z"/>
        </SvgIcon>
    );
}

function PlusSquare(props) {
    return (
        <SvgIcon fontSize="inherit" style={{width: 14, height: 14}} {...props}>
            {/* tslint:disable-next-line: max-line-length */}
            <path
                d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.401.294-.682t.669-.281v0q.401 0 .682.281t.281.682v4.896h4.923q.401 0 .682.281t.281.682v0q0 .375-.281.669t-.682.294z"/>
        </SvgIcon>
    );
}

function CloseSquare(props) {
    return (
        <SvgIcon
            className="close"
            fontSize="inherit"
            style={{width: 14, height: 14}}
            {...props}
        >
            {/* tslint:disable-next-line: max-line-length */}
            <path
                d="M17.485 17.512q-.281.281-.682.281t-.696-.268l-4.12-4.147-4.12 4.147q-.294.268-.696.268t-.682-.281-.281-.682.294-.669l4.12-4.147-4.12-4.147q-.294-.268-.294-.669t.281-.682.682-.281.696 .268l4.12 4.147 4.12-4.147q.294-.268.696-.268t.682.281 .281.669-.294.682l-4.12 4.147 4.12 4.147q.294.268 .294.669t-.281.682zM22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0z"/>
        </SvgIcon>
    );
}